import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../@shared/dialog/confirm-dialog/confirm-dialog.component';

export interface EditRaumData {
  id: string;
  name: string;
  sektionId: string;
  status?: number;
}

@Component({
  selector: 'app-edit-raum-dialog',
  templateUrl: './edit-raum-dialog.component.html',
  styleUrls: ['./edit-raum-dialog.component.css'],
})
export class EditRaumDialogComponent implements OnInit {
  frmRaum: UntypedFormGroup;
  raumId: string;
  sektionId: string;
  status: number = 1; // Default to active

  constructor(
    public dialogRef: MatDialogRef<EditRaumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRaumData,
    private _fb: UntypedFormBuilder,
    private dialog: MatDialog
  ) {
    this.raumId = data.id;
    this.sektionId = data.sektionId;
    this.status = data.status ?? 1; // Default to active if not provided

    this.frmRaum = this._fb.group({
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      sektion_id: [this.sektionId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmRaum.valid) {
      this.dialogRef.close({ 
        event: 'update', 
        data: {
          id: this.raumId,
          ...this.frmRaum.value
        }
      });
    }
  }

  onDelete(): void {
    const confirmed = confirm('Sind Sie sicher, dass Sie diesen Raum deaktivieren möchten? Er wird als inaktiv markiert und in der Historie angezeigt.');
    if (confirmed) {
      this.dialogRef.close({ 
        event: 'delete', 
        data: { 
          id: this.raumId,
          name: this.frmRaum.get('name')?.value || this.data.name
        }
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }

  isInactive(): boolean {
    return this.status === 0;
  }

  onRestore(): void {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: new ConfirmDialogModel(
        'Raum wiederherstellen',
        'Soll der Raum wiederhergestellt werden?',
        'Abbrechen',
        'Wiederherstellen'
      )
    });

    confirmDialog.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.dialogRef.close({
          event: 'restore',
          data: {
            id: this.raumId,
            status: 1
          }
        });
      }
    });
  }
}

